export class StudentSpecificScale{
    
    studentId: string;
    scaleValue: number;
    

}